var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcGiftWhiteLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.5 7.5h-15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1Z",
  stroke: "#fff",
  strokeWidth: 1.75,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.08 7.5c1.33.01 3.33-.18 4.29-1.15.41-.42.64-.87.7-1.34.09-.78-.11-1.44-.57-1.92-.47-.46-1.14-.66-1.92-.57-.47.05-.93.29-1.34.7-.98.96-1.19 2.81-1.17 4.15M11.98 7.5c-1.33.01-3.33-.18-4.29-1.15-.41-.42-.64-.87-.7-1.34-.09-.78.11-1.44.57-1.92.47-.46 1.14-.66 1.92-.57.47.05.93.29 1.34.7.98.96 1.19 2.81 1.17 4.15",
  stroke: "#fff",
  strokeWidth: 1.75,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 11.5v7a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2v-3M12 6.5v14",
  stroke: "#fff",
  strokeWidth: 1.75,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
})));
export default SvgIcGiftWhiteLine;